// Shared pure helpers for public menu: formatting, open-status, and theme tokens.
import { CURRENCIES } from "@/utils/localization";

export const DEFAULT_LOGO = "";

export function fmtPrice(amount, currency = "EUR") {
  if (typeof amount !== "number" || isNaN(amount)) amount = 0;
  const config = CURRENCIES[currency] || CURRENCIES.EUR;
  const formatted = amount.toFixed(2).replace(".", ",");
  return config.position === "before" ? `${config.symbol}${formatted}` : `${formatted}${config.symbol}`;
}

export function computeRestaurantStatus(restaurant) {
  const bh = restaurant?.business_hours;
  if (!bh || bh.length === 0) return 'open';
  const now = new Date();
  const dayNames = ["domingo", "lunes", "martes", "miercoles", "jueves", "viernes", "sabado"];
  const dayConfig = bh.find(h => h.day === dayNames[now.getDay()]);
  if (!dayConfig || !dayConfig.enabled) return 'closed';
  const currentMinutes = now.getHours() * 60 + now.getMinutes();
  const withinHours = (dayConfig.slots || []).some(slot => {
    if (!slot[0] || !slot[1]) return false;
    const [h1, m1] = slot[0].split(":").map(Number);
    const [h2, m2] = slot[1].split(":").map(Number);
    return currentMinutes >= h1 * 60 + m1 && currentMinutes <= h2 * 60 + m2;
  });
  if (!withinHours) return 'closed';
  return restaurant?.delivery_enabled !== false ? 'open' : 'pickup_only';
}

export function computeMenuTheme({ theme, BACKEND_BASE, products, restaurant }) {
  const bgColor = theme?.menu_colors?.bg || "#faf9f6";
  const isDarkCalc = theme?.dark_mode || (bgColor && parseInt(bgColor.replace('#', '').substring(0, 2), 16) < 80);
  const effectiveBg = isDarkCalc && parseInt(bgColor.replace('#', '').substring(0, 2), 16) > 180 ? "#0a0a0a" : bgColor;
  const tc = {
    primary: theme?.menu_colors?.primary || "#059669",
    secondary: theme?.menu_colors?.secondary || "#1f2937",
    accent: theme?.menu_colors?.accent || "#CDA34F",
    bg: effectiveBg,
    text: isDarkCalc
      ? (theme?.menu_colors?.text && parseInt(theme.menu_colors.text.replace('#', '').substring(0, 2), 16) > 180 ? theme.menu_colors.text : "#f3f4f6")
      : (theme?.menu_colors?.text || "#111827"),
    headerBg: theme?.menu_colors?.header_bg || "#ffffff",
    category: theme?.menu_colors?.category || "",
    price: theme?.menu_colors?.price || "",
  };
  const isDark = isDarkCalc;
  const cardBg = isDark ? '#111111' : '#ffffff';
  const cardBorder = isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)';
  const catColor = tc.category || tc.primary;
  const priceColor = tc.price || tc.primary;
  const logoUrl = (theme?.logo_url
    ? (theme.logo_url.startsWith("http") ? theme.logo_url : `${BACKEND_BASE}${theme.logo_url}`)
    : DEFAULT_LOGO) || DEFAULT_LOGO;
  const logoClass = (theme?.logo_format || "round") === "round" ? "rounded-full" : "rounded-lg";
  const bannerVideoUrl = theme?.banner_video_url
    ? (theme.banner_video_url.startsWith("http") ? theme.banner_video_url : `${BACKEND_BASE}${theme.banner_video_url}`)
    : "";
  const allAllergens = [...new Set((products || []).flatMap(p => p.allergens || []))];
  return { tc, isDark, cardBg, cardBorder, catColor, priceColor, logoUrl, logoClass, bannerVideoUrl, allAllergens };
}
